"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _jsxFileName = "/builds/schumacherweb/devbridge/ui-shared/549481182/shared/src/theme/icons/files/file-doc.svg.js",
    _path;

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function ReactComponent(props) {
  return React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 5
    },
    __self: this
  }), _path || (_path = React.createElement("path", {
    d: "M14 3l5.4 5.4v10.8a1.8 1.8 0 01-1.8 1.8H6.8A1.8 1.8 0 015 19.2V4.8C5 3.801 5.801 3 6.8 3H14zm-.9 6.3h4.95L13.1 4.35V9.3zm-6.554 7.784c0 .133.045.24.135.324.09.083.204.124.343.124a.49.49 0 00.346-.124.42.42 0 00.134-.324.426.426 0 00-.136-.328.487.487 0 00-.344-.126.483.483 0 00-.341.126.426.426 0 00-.137.328zm1.568-1.192c0 .523.113.932.338 1.226.226.294.525.44.898.44a.996.996 0 00.815-.395l.04.337h.765V13h-.85v1.617a.97.97 0 00-.764-.346c-.385 0-.688.147-.91.44-.221.293-.332.686-.332 1.18zm.846.061c0-.662.205-.993.613-.993.26 0 .442.11.548.331v1.251c-.108.22-.292.331-.554.331a.506.506 0 01-.451-.237c-.104-.158-.156-.386-.156-.683zm2.535-.067v.038c0 .504.136.902.408 1.195.273.293.638.44 1.095.44.457 0 .82-.147 1.092-.441.272-.294.408-.684.408-1.17l-.006-.218c-.032-.449-.182-.804-.453-1.066-.27-.262-.62-.393-1.047-.393-.301 0-.565.068-.793.203a1.33 1.33 0 00-.523.57 1.88 1.88 0 00-.181.842zm.846.061c0-.338.057-.587.17-.748a.553.553 0 01.48-.242c.21 0 .372.081.487.243.115.162.173.39.173.686 0 .345-.058.597-.173.754a.562.562 0 01-.48.236.56.56 0 01-.487-.239c-.113-.159-.17-.389-.17-.69zm3.996.929c-.203 0-.354-.071-.454-.214-.1-.142-.15-.377-.15-.703v-.088c0-.322.051-.555.152-.699a.51.51 0 01.447-.215c.16 0 .289.051.386.154a.577.577 0 01.153.4h.794c-.004-.375-.126-.676-.365-.901-.24-.226-.557-.339-.954-.339-.453 0-.81.146-1.07.437-.259.291-.389.68-.389 1.169v.056c0 .507.131.905.393 1.193.262.289.619.433 1.072.433.242 0 .463-.05.664-.148.2-.099.358-.238.473-.416.115-.18.174-.376.176-.59h-.794a.452.452 0 01-.153.342.555.555 0 01-.38.129z",
    __source: {
      fileName: _jsxFileName,
      lineNumber: 6
    },
    __self: this
  })));
}

var _default = ReactComponent;
exports["default"] = _default;